import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"

import "./switch.vue?vue&type=style&index=0&id=675cdc21&lang=scss"

const __exports__ = script;

export default __exports__